<template>
  <div>
    <v-container fluid class="py-6">
      <div class="d-sm-flex justify-between">
        <v-btn
            v-if="$store.state.is_approver"
            @click="confirmationDialog = true"
            elevation="0"
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-success
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        > VERIFY BATCH RECORDS </v-btn
        >
        <v-btn
            v-if="$store.state.is_administrator"
            elevation="0"
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-secondary
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        >ADD RETURNS RATE</v-btn>

        <div v-if="false" class="d-flex ms-auto">
          <v-menu transition="slide-y-transition" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  elevation="0"
                  :ripple="false"
                  height="43"
                  class="
                  font-weight-bold
                  text-uppercase
                  btn-default btn-outline-default
                  py-2
                  px-6
                  me-2
                "
                  color="transparent"
                  small
              >
                Filter By
                <v-icon>ni ni-bold-down text-xs ms-1</v-icon>
              </v-btn>
            </template>

            <v-list class="py-0">
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Approved
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Pending
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list-item-hover-active pb-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                  >
                    Status: Rejected
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <hr class="horizontal dark" />
              <v-list-item class="list-item-hover-active py-2">
                <v-list-item-content class="pa-0">
                  <v-list-item-title
                      class="text-danger ls-0 font-weight-600 mb-0"
                  >
                    Remove Filter
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-row>
        <v-col cols="12">
          <v-card class="card-shadow border-radius-xl">
            <div>
              <v-card class="card-shadow border-radius-xl mt-6">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                      :headers="headers"
                      :items="batchInfo"
                      :search="search"
                      class="table"
                      :page.sync="page"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      :items-per-page="itemsPerPage"
                      mobile-breakpoint="0"
                  >
                    <template v-slot:top>
                      <v-toolbar flat height="80">
                        <v-row>
                          <v-col cols="12" md="5">
                            <v-text-field
                                hide-details
                                class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                                dense
                                flat
                                filled
                                solo
                                height="43"
                                v-model="search"
                                placeholder="Search"
                            >
                              <template slot="prepend-inner">
                                <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                                >
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.id="{ item }">
                      <div class="d-flex align-center">
                        <v-checkbox
                            :ripple="false"
                            v-model="item.checkbox"
                            color="#141727"
                        ></v-checkbox>
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.id
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.date="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.date
              }}</span>
                    </template>

                    <template v-slot:item.status="{ item }">
                      <div class="d-flex align-center">
                        <v-btn
                            :ripple="false"
                            icon
                            outlined
                            rounded
                            width="25px"
                            height="25px"
                            class="me-2"
                            :class="
                  item.status == 'Approved'
                    ? 'border-success'
                    : 'border-warning'
                "
                        >
                          <v-icon
                              size="8"
                              :class="
                    item.status == 'Approved'
                      ? 'text-success'
                      : 'text-warning'
                  "
                          >
                            fas fa-check
                          </v-icon>
                        </v-btn>
                        <span class="text-body text-xs">{{ item.status }}</span>
                      </div>
                    </template>

                    <template v-slot:item.date_received="{ item }">
                      <div class="d-flex align-center">
                        <span class="text-body text-xs font-weight-bold">{{
                            item.date_received
                          }}</span>
                      </div>
                      <div class="d-flex align-center">
                        <span class="text-body text-xs font-weight-light">{{
                            item.payment_type
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.general_fund="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold"> $ {{
                          formatPrice(item.general_fund)
                        }}</span>
                    </template>

                    <template v-slot:item.other="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.other)
                        }}</span>
                    </template>

                    <template v-slot:item.unallocated_amount="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.unallocated_amount)
                        }}</span>
                    </template>

                    <template v-slot:item.interest="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.interest)
                        }}</span>
                    </template>

                    <template v-slot:item.total_amount="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold">$ {{
                          formatPrice(item.total_amount)
                        }}</span>
                    </template>

                    <template v-slot:item.week_range="{ item }">
                      <v-avatar size="24" class="me-2 bg-gradient-default" >
                        <span class="text-white text-xs">{{ item.record_number }}</span>
                      </v-avatar>
                      <span class="my-2 text-xs text-body font-weight-bold"> {{ item.week_range }} </span>
                    </template>

                    <template v-slot:item.action="{ item }">
                      <v-btn
                          @click="goToView(item)"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                          :class="
                    item.status == 'Approved'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >{{item.statusIcon == 'fas fa-check'
                          ? 'View'
                          : 'View'}}</v-btn
                      >
                    </template>

                    <template v-slot:item.download="{ item }">
                      <v-btn
                          @click=""
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2

                  "
                          :class="
                    item.status == 'Approved'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                      >
                        <v-icon size="18" class="rotate-180"
                        >fas fa-file-pdf text-lg me-1</v-icon
                        >
                        Download
                        </v-btn
                      >
                    </template>


                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row>
                    <v-col cols="6" lg="3" class="d-flex align-center">
                      <span class="text-body me-3 text-sm">Items per page:</span>
                      <v-text-field
                          hide-details
                          type="number"
                          outlined
                          min="-1"
                          max="15"
                          background-color="rgba(255,255,255,.9)"
                          color="rgba(0,0,0,.6)"
                          light
                          :value="itemsPerPage"
                          @input="itemsPerPage = parseInt($event, 10)"
                          placeholder="Items per page"
                          class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="ml-auto d-flex justify-end">
                      <v-pagination
                          prev-icon="fa fa-angle-left"
                          next-icon="fa fa-angle-right"
                          class="pagination"
                          color="#cb0c9f"
                          v-model="page"
                          :length="pageCount"
                          circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
            <div v-if="$store.state.is_administrator">
              <v-card class="card-shadow border-radius-xl mt-6">
                <v-card-text class="px-0 py-0">
                  <v-data-table
                      :headers="RatesHeaders"
                      :items="rates"
                      :search="search"
                      class="table"
                      :page.sync="page"
                      hide-default-footer
                      @page-count="pageCount = $event"
                      :items-per-page="itemsPerPage"
                      mobile-breakpoint="0"
                  >
                    <template v-slot:top>
                      <v-toolbar flat height="80">
                        <v-row>
                          <v-col cols="12" md="5">
                            <v-text-field
                                hide-details
                                class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                                dense
                                flat
                                filled
                                solo
                                height="43"
                                v-model="search"
                                placeholder="Search"
                            >
                              <template slot="prepend-inner">
                                <v-icon color="#adb5bd" size=".875rem"
                                >fas fa-search</v-icon
                                >
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-toolbar>
                    </template>

                    <template v-slot:item.dates="{ item }">
                      <div class="d-flex align-center">
                        <v-checkbox
                            :ripple="false"
                            v-model="item.checkbox"
                            color="#141727"
                        ></v-checkbox>
                        <span class="my-2 text-xs text-body font-weight-bold">{{
                            item.id
                          }}</span>
                      </div>
                    </template>

                    <template v-slot:item.dates="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                 new Date(item.start_date).toDateString()
              }} to {{ new Date(item.end_date).toDateString() }}</span>
                    </template>

                    <template v-slot:item.amount="{ item }">
                      <span class="my-2 text-xs text-body font-weight-bold"> USD {{ ((item.amount).toFixed(2)) }}</span>
                    </template>

                    <template v-slot:item.edit="{ item }">
                      <v-btn
                          @click="goToo()"
                          elevation="0"
                          small
                          :ripple="false"
                          height="21"
                          class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                    bg-gradient-success
                  "


                      >EDIT</v-btn
                      >
                    </template>

                    <template v-slot:item.invoice="{ item }">
                      <v-btn
                          color="#fff"
                          class="text-dark font-weight-bolder px-1 shadow-0"
                          small
                          simple
                      >
                        <v-icon size="18" class="rotate-180"
                        >fas fa-file-pdf text-lg me-1</v-icon
                        >
                        Pdf
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="card-padding">
                  <v-row>
                    <v-col cols="6" lg="3" class="d-flex align-center">
                      <span class="text-body me-3 text-sm">Items per page:</span>
                      <v-text-field
                          hide-details
                          type="number"
                          outlined
                          min="-1"
                          max="15"
                          background-color="rgba(255,255,255,.9)"
                          color="rgba(0,0,0,.6)"
                          light
                          :value="itemsPerPage"
                          @input="itemsPerPage = parseInt($event, 10)"
                          placeholder="Items per page"
                          class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="6" class="ml-auto d-flex justify-end">
                      <v-pagination
                          prev-icon="fa fa-angle-left"
                          next-icon="fa fa-angle-right"
                          class="pagination"
                          color="#cb0c9f"
                          v-model="page"
                          :length="pageCount"
                          circle
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog
          v-model="successDialog"
          max-width="290"
          persistent
      >
        <v-card class="text-center ">
          <v-card-title class="text-h5 justify-center">
            Success
          </v-card-title>

          <v-card-text>
            Your upload has been done
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
                color="green darken-1"
                text
                outlined
                @click="goTo()"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="confirmationDialog"
          max-width="290"
          persistent
      >
        <v-card class="text-center ">
          <v-card-title class="text-h5 justify-center">
            Confirm Approval
          </v-card-title>

          <v-card-text>
            Are you sure you want to approve these records ?
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
                color="green darken-1"
                text
                outlined
                @click="confirmationDialog = false; approveBatch()"
            >
              Yes
            </v-btn>
            <v-btn
                color="red darken-1"
                text
                outlined
                @click="confirmationDialog = false"
            >
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="errorDialog"
          max-width="290"
          persistent
      >
        <v-card class="text-center ">
          <v-card-title class="text-h5 justify-center">
            Error
          </v-card-title>

          <v-card-text>
            There was an error adding your returns
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
                color="danger darken-1"
                text
                outlined
                @click="errorDialog = false"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>

import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "Returns-List",
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      successDialog: false,
      errorDialog: false,
      confirmationDialog: false,
      batchInfo:[],
      rates:[],
      search: "",
      headers: [
        {
          text: "Weeks #",
          align: "start",
          sortable: false,
          value: "week_range",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "Status",
          value: "status",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Received Date",
          value: "date_received",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Other",
          value: "other",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Unallocated",
          value: "unallocated_amount",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "General Fund",
          value: "general_fund",
          class: "text-secondary font-weight-bolder opacity-7",
        },
        {
          text: "Interest",
          value: "interest",
          class: "text-secondary font-weight-bolder opacity-7",
        },

        {
          text: "Total Amount",
          value: "total_amount",
          class: "text-secondary font-weight-bolder opacity-7",
        },

      ],
      RatesHeaders: [
        {
          text: "SW1",
          align: "start",
          sortable: false,
          value: "SkilledWorker1",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "SW2",
          align: "start",
          sortable: false,
          value: "SkilledWorker2",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "SW3",
          align: "start",
          sortable: false,
          value: "SkilledWorker3",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "SW4",
          align: "start",
          sortable: false,
          value: "SkilledWorker4",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "W E",
          align: "start",
          sortable: false,
          value: "WorkerExempt",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "BEI & WM",
          align: "start",
          sortable: false,
          value: "BEIWM",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "F L",
          align: "start",
          sortable: false,
          value: "FloorLayer",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "WG1",
          align: "start",
          sortable: false,
          value: "WorkerGrade1",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "WG2",
          align: "start",
          sortable: false,
          value: "WorkerGrade2",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "WG3",
          align: "start",
          sortable: false,
          value: "WorkerGrade3",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "WG4",
          align: "start",
          sortable: false,
          value: "WorkerGrade4",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "W M",
          align: "start",
          sortable: false,
          value: "Watchmen",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "Dates",
          align: "center",
          sortable: false,
          value: "dates",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
        {
          text: "Edit",
          align: "center",
          sortable: false,
          value: "edit",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },



      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  created () {
    this.getBatchRecords()

  },
  computed: {
    ...mapState(['base_url']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    async getRecords() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/ledger/get-all-records/USD/', { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.returns = res.data
              console.log("info", this.returns)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    async getRates() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/returns/get-grades/', { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.rates = res.data
              console.log(this.returns)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },

    async approveBatch() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/ledger/approve-batch/' + this.$route.query.id, { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.getBatchRecords()
              console.log("info", this.returns)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },

    async getBatchRecords() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/ledger/get-batch-records/' + this.$route.query.id, { headers: { Authorization: `Bearer ${JWTToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.batchInfo = res.data
              console.log(this.batchInfo)
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },



    goTo(item){
      this.$router.push({
        name: "Comment Returns",
        params: { id: item.id },
        query: { id: item.batchnumber , },
      });
    },
    goToAdd(){
      this.$router.push("/admin-add-usd-ledgers");
    }
  },
};
</script>
